var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"validate-button",class:{'success-button':_vm.verifiable}},[_vm._t("default"),(_vm.loading)?_c('i',{staticClass:"el-icon-loading"}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }